import { IStakeHolder } from '../../interface/IPayload';
import { ROUTE_NAMES } from '../../../router/RouterApp';
import { displayFullName, stripTrailingSlashes } from '@flos/react-components';

export function getStepCount(): number {
  return Object.keys(ROUTE_NAMES).length;
}

/**
 * PAJ - Scroll to a absolute Y axis postion in window
 * Fix for auto-scroll - Mobile screens - US 119415
 * @param offset number - offset by a number
 * @param behavior 'smooth' | 'auto' - behavior by 'smooth' | 'auto'
 */
export const scrollToWindowYPosition = (offset: number, behavior: 'smooth' | 'auto') => {
  window.scrollTo({
    top: offset,
    behavior: behavior
  });
};

export function pathNameMatch(pathName: string, match: string) {
  const p1 = stripTrailingSlashes(pathName);
  const p2 = p1 + '/';
  return p1 === match || p2 === match;
}

export function getStakeholderData(obj: any): IStakeHolder {
  let stakeholder = {
    fullName: '',
    firstName: obj.firstName || '',
    lastName: obj.lastName || '',
    cprNo: obj.cprNo || '',
    customerId: obj.customerId || '',
    emailAddress: obj.emailAddress || '',
    emailPriority: obj.emailPriority || 0,
    mobilePhone: obj.mobilePhone || '',
    streetAddress: obj.streetAddress || '',
    zipCity: obj.zipCity || '',
    village: obj.village || '',
    country: obj.country || '',
    fullAddress: ''
  } as IStakeHolder;

  stakeholder.fullName = displayFullName(stakeholder.firstName, stakeholder.lastName);

  const village = obj.village ? `${obj.village}, ` : '';
  stakeholder.fullAddress = `${obj.streetAddress}, ${village}${obj.zipCity}`;

  return stakeholder;
}

export function getContactUsURL() {
  const siteConfig = window.topContext.config.getSiteConfig();
  const originalHost = siteConfig.originalHost || 'www.topdanmark.dk';
  return `https://${originalHost}/faa-hjaelp/kontakt-os/`;
}
